import { IndexedDBService } from "../services/indexedDbService";
/* import { closeSessionChatIa } from "./closeSession"; */

const indexedDbService = new IndexedDBService();

//Retorna a la vista de login y limpia el localstorage
export const returnToSignin = (navigate) => {
  /* let chatSessionId = localStorage.getItem("chatSessionId");
  let chatHistory = localStorage.getItem("chatHistory"); */
  localStorage.clear();
  localStorage.setItem("is_signin", false);
  indexedDbService.clearStore()
    .then(() => console.log('Almacén limpiado'))
    .catch(e => console.log(e));
  /* clearAllData()
    .then(() => console.log('Datos borrados de almacén chatia_db'))
    .catch(e => console.log(e)); */
  /* closeSessionChatIa(chatSessionId, chatHistory)
    .then(() => console.log('Sesión IA cerrada'))
    .catch(e => console.log(e)); */
  return navigate("/ingresar");
}